import { useState, useEffect, useRef } from "react";

function useResizeObserver(delay = 200) {
  const [dimensions, setDimensions] = useState({});
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const debouncedHandleResize = function () {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        const bounds = ref.current.getBoundingClientRect();
        setDimensions(bounds);
      }, delay);
    };

    const observer = new ResizeObserver(debouncedHandleResize);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      clearTimeout(timeoutRef.current);
      observer.disconnect();
    };
  }, [delay, ref]);

  return [ref, dimensions];
}

export default useResizeObserver;
